export default "__VITE_ASSET__5ce2710c__"